(function () {
  'use strict';

  /* ── Sanitize ── */
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ── Render JSON → <table> ── */
  function renderTable(table) {
    if (table.dataset.scRendered) return;
    try {
      var data = JSON.parse(table.dataset.scJson);
      var html = '<thead><tr>';
      data.columns.forEach(function (col) {
        html += '<th>' + esc(col) + '</th>';
      });
      html += '</tr></thead><tbody>';
      data.rows.forEach(function (row) {
        html += '<tr>';
        row.forEach(function (cell, i) {
          html += i === 0
            ? '<th scope="row">' + esc(cell) + '</th>'
            : '<td>' + esc(cell) + '</td>';
        });
        html += '</tr>';
      });
      html += '</tbody>';
      table.innerHTML = html;
      table.dataset.scRendered = '1';
    } catch (e) {
      console.warn('[size-charts] JSON parse error', e);
    }
  }

  function renderAllVisible() {
    document.querySelectorAll(
      '.size-chart-table[data-sc-json]:not([data-sc-rendered])'
    ).forEach(renderTable);
  }

  /* ── Product page: toggle ── */
  function initProductToggle(btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var panel  = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      if (!isOpen) renderAllVisible();
    });
  }

  /* ── Standalone page: mobile accordion ── */
  function initMobileAccordion() {
    document.querySelectorAll('.size-chart-card').forEach(function (card) {
      var titleEl = card.querySelector('.size-chart-card-title');
      if (!titleEl) return;
      titleEl.addEventListener('click', function () {
        var opening = card.classList.toggle('is-open');
        if (opening) renderAllVisible();
      });
      titleEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          titleEl.click();
        }
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.size-chart-toggle-btn').forEach(initProductToggle);
    initMobileAccordion();
    renderAllVisible();
  });
})();